export default __webpack_public_path__ + "static/media/200_3 1.03af213c.svg";